import { select, selectAll } from 'helpers/dom'

const selectors = {
  CAROUSEL_SWIPER_SELECTOR: 'js-carousel-swiper',
  CAROUSEL_SWIPER_PREV_SELECTOR: '.js-carousel-prev',
  CAROUSEL_SWIPER_NEXT_SELECTOR: '.js-carousel-next',
  PAGINATION_SELECTOR: '.js-carousel-pagination',
  SCROLL_BAR_SELECTOR: '.js-carousel-scrollbar',
  THRESHOLD_TO_RUN: 10,
  INTERVAL_TIMEOUT: 300
}

class SwiperInstance {
  constructor(element, options, config) {
    this.element = element
    this.selector = element.getAttribute('data-selector') || selectors.CAROUSEL_SWIPER_SELECTOR
    this.type = element.getAttribute('data-type') || null
    this.swiper = null
    this.setOptions(options || {}, config)
    this.initCarousel()
  }

  setOptions(options, config) {
    const { navigation, pagination, scrollbar } = options || {}

    const navEl = {
      prevEl: select(selectors.CAROUSEL_SWIPER_PREV_SELECTOR, this.element),
      nextEl: select(selectors.CAROUSEL_SWIPER_NEXT_SELECTOR, this.element)
    }

    const paginationEl = select(selectors.PAGINATION_SELECTOR, this.element)
    const scrollbarEl = select(selectors.SCROLL_BAR_SELECTOR, this.element)

    let thumbnail = {}

    if (config.thumbnail) {
      const thumbnailEl = select(config.thumbnail)

      thumbnail = {
        thumbs: {
          swiper: thumbnailEl,
          multipleActiveThumbs: false
        }
      }
    }

    this.options = {
      ...options,
      navigation: config.navigation && { ...navigation, ...navEl },
      pagination: config.pagination && { ...pagination, el: paginationEl },
      scrollbar: config.scrollbar && { ...scrollbar, el: scrollbarEl },
      direction: options.direction || 'horizontal',
      lazy: options.lazy || true,
      zoom: config.zoom || false,
      grid: config.grid || false,
      keyboard: {
        enabled: config.keyboard || false,
        onlyInViewport: config.onlyInViewport || true
      },
      ...thumbnail
    }

    if (config.customPagination) {
      this.options.pagination.type = 'fraction'

      this.options.pagination.formatFractionCurrent = (number) => {
        return number
      }
    }
  }

  initCarousel() {
    if (this.type === 'native') {
      const checkSelectorItems = selectAll(`.${this.selector}`)

      if (!checkSelectorItems.length) {
        return
      }

      if (checkSelectorItems.length > 1) {
        // eslint-disable-next-line no-console
        console.error('Swiper: Multiple instances of the same selector are not supported', checkSelectorItems)

        // return
      }

      // this.swiper = new Swiper(`.${this.selector}`, this.options)
    } else {
      this.swiper = select(`.${this.selector}`, this.element)

      if (!this.swiper?.initialize || !this.swiper) {
        let count = 0

        const interval = setInterval(() => {
          count++

          if (this.swiper?.initialize) {
            clearInterval(interval)
            Object.assign(this.swiper, this.options)
            this.swiper.initialize()
          }
        }, selectors.INTERVAL_TIMEOUT)
      } else {
        Object.assign(this.swiper, this.options)
        this.swiper.initialize()
      }
    }
  }
}

export default SwiperInstance
